import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { hiddenDown, hiddenUp, px2rem } from '@/theme';

export const PerkWrapper = styled(Box)`
  ${({ theme }) => css`
    * {
      transition: ${theme.transitions.create('color')};
    }

    &:hover * {
      color: ${theme.colors.primary};
    }
  `}
`;

export const Text = styled(Box)`
  white-space: nowrap;
  text-transform: uppercase;

  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
    font-family: ${theme.fontFamilies.italianPlate};
    color: ${theme.colors.secondary};
  `};
`;

export interface WrapperProps {
  mdHidden?: boolean;
  mdVisible?: boolean;
  variant: 'desktop' | 'mobile';
}

export const Wrapper = styled(Flex)<WrapperProps>`
  padding-top: ${({ theme }) => theme.spacing(2.5)};

  ${({ mdHidden, mdVisible, theme, variant }) => css`
    ${variant === 'mobile' &&
    css`
      justify-content: center;
      gap: ${px2rem(47)};
      flex-wrap: wrap;
    `}

    ${mdHidden && hiddenUp('md')}
    ${mdVisible && hiddenDown('md')}
    
    ${theme.media.md.up} {
      margin: 0;
      justify-content: space-evenly;
    }
  `}
`;
